export default __webpack_public_path__ + "static/media/Ballad_Health_Icon_Logo.77baff8b.png";